import { font, color, space, query } from '@design/templateFns';
import styled from 'styled-components';

export const RichTextWrapper = styled.div`
  a {
    color: ${color('fg')};
    text-decoration: underline;

    &:hover {
      color: #757575;
    }
  }

  b {
    font-weight: 700;
  }

  i {
    font-style: italic;
  }

  p {
    margin: ${space('xl')} 0;

    &:first-child {
      margin-top: 0;
    }
  }
`;

export const LinkWrapper = styled.span`
  a {
    font-weight: 200;
    ${font('body-sm-light')}

    @media screen and (${query.atLeast('tablet')}) {
      ${font('body-md-light')}
    }
  }
`;

export const Header1 = styled.h1`
  display: block;
  padding: 0;
  margin-bottom: ${space('lg')};
  ${font('headline-xl')};
  font-size: 35px;
`;

export const Header2 = styled.h2`
  display: block;
  padding: 0;
  margin-bottom: ${space('lg')};
  ${font('headline-lg')};
  font-size: 30px;
`;

export const Header3 = styled.h3`
  display: block;
  padding: 0;
  margin-bottom: ${space('lg')};
  ${font('headline-md')}
`;

export const Header4 = styled.h4`
  display: block;
  padding: 0;
  margin-bottom: ${space('lg')};
  ${font('headline-sm')};
  font-size: 22px;
`;

export const Header5 = styled.h5`
  display: block;
  padding: 0;
  margin-bottom: ${space('lg')};
  line-height: 24px !important;
  ${font('headline-xs')};
  font-size: 20px;
`;

export const Header6 = styled.h6`
  display: block;
  padding: 0;
  margin-bottom: ${space('lg')};
  ${font('headline-xxs')};
  font-size: 14px;
`;

export const Eyebrow = styled.h6`
  ${font('headline-xxs')};
  font-size: 14px;
  color: ${color('cta')};
  text-transform: uppercase;
  padding-bottom: 0;
  margin-bottom: ${space('lg')};
`;

export const Quote = styled.div`
  p {
    ${font('headline-sm')}
  }
`;

export const Paragraph = styled.p`
  display: block;
  margin-bottom: ${space('x7')};
  padding-bottom: 0;
  ${font('body-sm-light')}
  @media screen and (${query.atLeast('tablet')}) {
    ${font('body-md-light')}
  }
`;

export const Ul = styled.ul`
  list-style: initial;
  padding-left: ${space('x7')};
  margin-bottom: ${space('x7')};
  ${font('body-sm-light')}
  list-style-type: none;
  position: relative;

  li::marker {
    ${font('body-sm-light')}
    font-size: 8px;
  }

  li::before {
    content: '·';
    line-height: 19px;
    position: absolute;
    font-size: 24px;
    left: 25px;
  }

  p {
    margin: 0;

    & + p {
      margin-top: ${space('sm')};
    }
  }
`;

export const Ol = styled.ol`
  list-style: decimal;
  padding-left: ${space('x7')};
  margin-bottom: ${space('x7')};

  ${font('body-sm-light')}

  li::marker {
    ${font('body-sm-light')}
  }

  p {
    margin-bottom: ${space('sm')};

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
